// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2jPL1","messages":"Chat_messages__3Sxl9","dateDivider":"Chat_dateDivider__831X9"};